import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Form from "react-bootstrap/lib/Form";
import cloneDeep from "lodash.clonedeep";
import { QuestionType } from "../../../utils/enums";
import { QuestionRankingField } from "./QuestionRankingField";
import { arrayMove } from "../../../helpers/ArrayMove";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.min.css";
import ReactTooltip from "react-tooltip";

import moment from "moment";
import "moment/locale/pl";
import { QuestionContainer } from "./QuestionContainer";
import forEach from "lodash.foreach";

export class Question extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltip: {
        0: false,
      },
      questionOptions: this.props.questionOptions
        ? this.props.questionOptions
        : [],
    };
  }

  toggle = (key) => {
    this.setState((prevState) => ({
      ...prevState,
      [key]: !this.state.tooltip[key],
    }));
  };

  updateRankingAnswer(questionOptionsToUpdate, questionAnswer) {
    if (
      questionAnswer.answerOptions[0] &&
      questionAnswer.answerOptions[0].id > 0
    ) {
      let answerToUpdate = cloneDeep(questionAnswer);
      answerToUpdate.answerOptions = questionOptionsToUpdate.map(
        (item, index) => ({
          id: 0,
          comment: "",
          openText: "",
          openDate: null,
          questionOptionId: item.id,
          questionMatrixValueId: 0,
          ranking: index + 1,
        })
      );
      this.props.setFieldValue(
        `${this.props.prefixName}answers[0]`,
        answerToUpdate
      );
    } else {
      let newAnswer = [
        {
          id: 0,
          questionId: this.props.id,
          userId: this.props.loggedUserId,
          categoryId: this.props.categoryId,
          answerOptions: questionOptionsToUpdate.map((item, index) => ({
            id: 0,
            comment: "",
            openText: "",
            openDate: null,
            questionOptionId: item.id,
            questionMatrixValueId: 0,
            ranking: index + 1,
          })),
        },
      ];
      this.props.setFieldValue(`${this.props.prefixName}answers`, newAnswer);
    }
  }
  movePosition(questionOptions, oldIndex, newIndex, questionAnswer) {
    const questionOptionsToUpdate = arrayMove(
      questionOptions,
      oldIndex,
      newIndex
    );

    this.setState({
      questionOptions: questionOptionsToUpdate,
    });
    this.updateRankingAnswer(questionOptionsToUpdate, questionAnswer);
  }
  moveUp(idx, questionAnswer, questionOptions) {
    let questionOptionsToUpdate = questionOptions;
    let questionOptionAbove = questionOptionsToUpdate[idx - 1];
    let questionOptionUnder = questionOptionsToUpdate[idx];

    questionOptionsToUpdate[idx - 1] = questionOptionUnder;
    questionOptionsToUpdate[idx] = questionOptionAbove;
    this.setState({
      questionOptions: questionOptionsToUpdate,
    });
    this.updateRankingAnswer(questionOptionsToUpdate, questionAnswer);
    return;
  }
  moveDown(idx, questionAnswer, questionOptions) {
    let questionOptionsToUpdate = questionOptions;
    let questionOptionAbove = questionOptionsToUpdate[idx];
    let questionOptionUnder = questionOptionsToUpdate[idx + 1];
    questionOptionsToUpdate[idx] = questionOptionUnder;
    questionOptionsToUpdate[idx + 1] = questionOptionAbove;
    this.setState({
      questionOptions: questionOptionsToUpdate,
    });
    this.updateRankingAnswer(questionOptionsToUpdate, questionAnswer);
    return;
  }

  //na razie zostawiam chociaż metoda bezsensowana na razie
  getQuestionAnswer(questionOptions) {
    if (
      [
        QuestionType.SingleRadio,
        QuestionType.SingleText,
        QuestionType.SingleDate,
        QuestionType.MultipleCheck,
        QuestionType.Ranking,
        QuestionType.Matrix,
        QuestionType.Budget,
      ].includes(this.props.questionType)
    ) {
      //'Proste (radio)'
      return this.props.questionAnswer ? this.props.questionAnswer : undefined;
    }
  }

  onSingleChange(questionAnswer, value) {
    const questionOptionsUpdates = [];
    if (
      questionAnswer.answerOptions[0] &&
      (questionAnswer.answerOptions[0].id > 0 ||
        questionAnswer.answerOptions[0].questionOptionId > 0)
    ) {
      let answerToUpdate = cloneDeep(questionAnswer);
      if (this.props.questionType == QuestionType.SingleRadio) {
        answerToUpdate.answerOptions[0].questionOptionId = value;
        const { questionOptions } = this.props;
        forEach(questionOptions, (questionOption, questionOptionIndex) => {
          forEach(questionOption.questions, (question, questionIndex) => {
            questionOptionsUpdates.push({
              key: `${this.props.prefixName}questionOptions.${questionOptionIndex}.questions.${questionIndex}.answers`,
              value: [],
            });
          });
        });
      } else if (this.props.questionType == QuestionType.SingleText) {
        answerToUpdate.answerOptions[0].openText = value;
      } else if (this.props.questionType == QuestionType.SingleDate) {
        answerToUpdate.answerOptions[0].openDate = value;
      } else if (this.props.questionType == QuestionType.MultipleCheck) {
        let newAnswerOption = {
          id: 0,
          comment: "",
          openText: "",
          openDate: null,
          questionOptionId: value,
          questionMatrixValueId: 0,
        };
        answerToUpdate.answerOptions.push(newAnswerOption);
      }
      this.props.setFieldValue(`${this.props.prefixName}answers`, [
        answerToUpdate,
      ]);
      forEach(questionOptionsUpdates, (update) =>
        this.props.setFieldValue(update.key, update.value)
      );
    } else {
      let newAnswer = [
        {
          id: 0,
          questionId: this.props.id,
          userId: this.props.loggedUserId,
          categoryId: this.props.categoryId,
          answerOptions: [
            {
              id: 0,
              comment: "",
              openText:
                this.props.questionType == QuestionType.SingleText ? value : "",
              openDate:
                this.props.questionType == QuestionType.SingleDate
                  ? value
                  : null,
              questionOptionId:
                this.props.questionType == QuestionType.SingleRadio ||
                this.props.questionType == QuestionType.MultipleCheck
                  ? value
                  : 0,
              questionMatrixValueId: 0,
            },
          ],
        },
      ];
      this.props.setFieldValue(`${this.props.prefixName}answers`, newAnswer);
    }
  }
  onSingleCommentChange(questionAnswer, value) {
    let answerToUpdate = cloneDeep(questionAnswer);
    if (
      this.props.questionType == QuestionType.SingleRadio ||
      this.props.questionType == QuestionType.SingleText ||
      this.props.questionType == QuestionType.SingleDate
    ) {
      answerToUpdate.answerOptions[0].comment = value;
    }
    this.props.setFieldValue(
      `${this.props.prefixName}answers[0]`,
      answerToUpdate
    );
  }
  onMultipleCommentChange(questionAnswer, value, questionOptionId) {
    let answerToUpdate = cloneDeep(questionAnswer);
    if (this.props.questionType == QuestionType.MultipleCheck) {
      let answerOptionToUpdate = answerToUpdate.answerOptions.filter(
        (options) => options.questionOptionId == questionOptionId
      );
      let answerOptionsNotToUpdate = answerToUpdate.answerOptions.filter(
        (options) => options.questionOptionId != questionOptionId
      );
      answerOptionToUpdate[0].comment = value;
      answerToUpdate.answerOptions = answerOptionsNotToUpdate;
      answerToUpdate.answerOptions.push(answerOptionToUpdate[0]);
    }
    this.props.setFieldValue(
      `${this.props.prefixName}answers[0]`,
      answerToUpdate
    );
  }

  render() {
    let { questionOptions } = this.state;
    const { subQuestion, isPreview = false } = this.props;
    let questionAnswer = this.getQuestionAnswer(questionOptions);
    if (this.props.questionType == QuestionType.Ranking) {
      if (
        questionAnswer.answerOptions[0] &&
        questionAnswer.answerOptions[0].id > 0
      ) {
        let items = questionOptions;
        let sorting = questionAnswer.answerOptions.map(
          (item) => item.questionOptionId
        );
        let result = [];
        sorting.forEach(function (key) {
          var found = false;
          items = items.filter(function (item) {
            if (!found && item.id == key) {
              result.push(item);
              found = true;
              return false;
            } else return true;
          });
        });
        questionOptions = result;
      }
    }

    return (
      <div className="box margin-top-20">
        <div style={{ display: "flex" }}>
          <h2
            className={`title ${
              subQuestion ? "title--small" : "title--sub title--bottom-40"
            } title--alert title--top-0`}
          >
            {`${subQuestion ? "" : `${this.props.rowId}.`} ${
              this.props.content
            }`}{" "}
          </h2>
          {this.props.tooltip && (
            <i
              data-tip={this.props.tooltip}
              ref={(ref) => (this.fooRef = ref)}
              className="fas fa-info-circle"
              style={{ marginLeft: 8, marginTop: 8 }}
            ></i>
          )}

          <ReactTooltip />
        </div>
        <div className="survey-question-options">
          {this.props.questionType == QuestionType.SingleRadio && (
            <div className="question-options" role="radiogroup">
              {this.props.questionOptions.length > 0 &&
                this.props.questionOptions.map((item, index) => (
                  <Fragment>
                    <p
                      style={{
                        visibility: "hidden",
                        width: "0px",
                        height: "0px",
                        display: "none",
                      }}
                      id={`question-${this.props.rowId}-${index}`}
                    >
                      {`${item.content} odpowiedź do pytania ${this.props.rowId}`}
                    </p>
                    <label
                      className="question-options__option radio"
                      key={`question-${this.props.rowId}-${index}`}
                      tabIndex="0"
                      role="radio"
                      aria-label={`${item.content} odpowiedź do pytania ${this.props.rowId}`}
                    >
                      <input
                        type="radio"
                        disabled={this.props.disabled}
                        className="question-options__option-input"
                        onBlur={this.props.onBlur}
                        onChange={(e) => {
                          this.onSingleChange(
                            questionAnswer,
                            parseInt(e.target.value)
                          );
                          // this.props.onChange(e);
                        }}
                        name={`${this.props.prefixName}answers`}
                        value={item.id}
                        checked={
                          item.id ===
                          (questionAnswer.answerOptions[0]
                            ? questionAnswer.answerOptions[0].questionOptionId
                            : -1)
                        }
                        aria-labelledby={`question-${this.props.rowId}-${index}`}
                      />
                      <span className="row row--align-center question-options__option-button">
                        {item.content}
                      </span>
                    </label>
                    {(!isPreview
                      ? item.id ===
                        (questionAnswer.answerOptions[0]
                          ? questionAnswer.answerOptions[0].questionOptionId
                          : -1)
                      : true) && (
                      <QuestionContainer
                        items={item.questions}
                        categoryId={this.props.id}
                        categoryIndex={this.props.categoryIndex}
                        consultationFormType={this.props.consultationFormType}
                        isResultPublished={this.props.isResultPublished}
                        disabled={
                          this.props.disabled ||
                          item.id !==
                            (questionAnswer.answerOptions[0]
                              ? questionAnswer.answerOptions[0].questionOptionId
                              : -1)
                        }
                        formIndex={this.props.formIndex}
                        prefixName={`${this.props.prefixName}questionOptions.${index}.`}
                        loggedUserId={this.props.loggedUserId}
                        projectType={this.props.projectType}
                        onChange={this.props.onChange}
                        onBlur={this.props.onBlur}
                        setFieldValue={this.props.setFieldValue}
                        errors={
                          this.props.errors.questionOptions
                            ? this.props.errors.questionOptions[index]
                            : this.props.errors
                        }
                        isAuth={this.props.isAuth}
                        availableVoteNotLogged={
                          this.props.availableVoteNotLogged
                        }
                        subQuestion={true}
                      />
                    )}
                  </Fragment>
                ))}
              {typeof this.props.errors.answers === "string" && (
                <Form.Control.Feedback
                  type="invalid"
                  className="field--invalid"
                >
                  {this.props.errors.answers}
                </Form.Control.Feedback>
              )}
              {this.props.canComment && (
                <div className="field field--question margin-top-10">
                  <Form.Control
                    disabled={
                      this.props.disabled ||
                      questionAnswer.answerOptions[0] == null ||
                      questionAnswer.answerOptions[0].questionOptionId == 0
                    }
                    id={`${this.props.prefixName}comment`}
                    name={`${this.props.prefixName}comment`}
                    type="text"
                    value={
                      questionAnswer.answerOptions[0]
                        ? questionAnswer.answerOptions[0].comment
                        : ""
                    }
                    placeholder={"Skomentuj odpowiedź"}
                    className="field__input"
                    onChange={(e) => {
                      this.onSingleCommentChange(
                        questionAnswer,
                        e.target.value
                      );
                      // this.props.onChange(e);
                    }}
                    autocomplete="off"
                  />
                </div>
              )}
            </div>
          )}
          {this.props.questionType == QuestionType.SingleText && (
            <Form.Row>
              <Form.Group>
                <div className="field field--question">
                  <p
                    style={{
                      visibility: "hidden",
                      width: "0px",
                      height: "0px",
                      display: "none",
                    }}
                    id={`question-${this.props.rowId}`}
                  >
                    {`${
                      questionAnswer.answerOptions[0]
                        ? questionAnswer.answerOptions[0].openText
                        : ""
                    } odpowiedź do pytania ${this.props.rowId}`}
                  </p>
                  <Form.Control
                    disabled={this.props.disabled}
                    id={`${this.props.prefixName}answers`}
                    name={`${this.props.prefixName}answers`}
                    value={
                      // this.props.defaultValue &&
                      // (!questionAnswer.answerOptions[0] ||
                      //   !questionAnswer.answerOptions[0].openText)
                      //   ? this.props.defaultValue
                      //   :
                      questionAnswer.answerOptions[0]
                        ? questionAnswer.answerOptions[0].openText
                        : ""
                    }
                    onChange={(e) => {
                      this.onSingleChange(questionAnswer, e.target.value);
                      // this.props.onChange(e);
                    }}
                    className="field__input"
                    onBlur={this.props.onBlur}
                    placeholder={this.props.placeholder}
                    title="Wpisz twoją odpowiedź na pytanie"
                    isInvalid={!!this.props.errors.answers}
                    autocomplete="off"
                    aria-labelledby={`question-${this.props.rowId}`}
                  />
                </div>
                {typeof this.props.errors.answers === "string" && (
                  <Form.Control.Feedback
                    type="invalid"
                    className="field--invalid"
                  >
                    {this.props.errors.answers}
                  </Form.Control.Feedback>
                )}
                {this.props.canComment && (
                  <div className="field field--question">
                    <Form.Control
                      disabled={
                        this.props.disabled ||
                        questionAnswer.answerOptions[0] == null ||
                        questionAnswer.answerOptions[0].openText === ""
                      }
                      id={`${this.props.prefixName}comment`}
                      name={`${this.props.prefixName}comment`}
                      type="text"
                      value={
                        questionAnswer.answerOptions[0]
                          ? questionAnswer.answerOptions[0].comment
                          : ""
                      }
                      placeholder={"Skomentuj odpowiedź"}
                      className="field__input"
                      onChange={(e) => {
                        this.onSingleCommentChange(
                          questionAnswer,
                          e.target.value
                        );
                        // this.props.onChange(e);
                      }}
                      autocomplete="off"
                    />
                  </div>
                )}
              </Form.Group>
            </Form.Row>
          )}
          {this.props.questionType == QuestionType.SingleDate && (
            <Form.Group>
              <div className="field field--question">
                <label for={`${this.props.prefixName}answers`}>
                  <span
                    style={{
                      visibility: "hidden",
                      width: "0px",
                      height: "0px",
                      display: "none",
                    }}
                  >
                    &nbsp;
                  </span>
                  <DatePicker
                    className="field__input field__input--datepicker"
                    dateFormat="YYYY-MM-DD"
                    disabled={this.props.disabled && false}
                    id={`${this.props.prefixName}answers`}
                    name={`${this.props.prefixName}answers`}
                    selected={
                      this.props.defaultValue &&
                      !questionAnswer.answerOptions[0]
                        ? this.props.defaultValue
                        : questionAnswer.answerOptions[0] &&
                          questionAnswer.answerOptions[0].openDate
                        ? moment(questionAnswer.answerOptions[0].openDate)
                        : null
                    }
                    onChange={(date) => {
                      if (date) {
                        const newDate = date.format("YYYY-MM-DD");
                        this.onSingleChange(questionAnswer, newDate);
                      } else {
                        this.onSingleChange(questionAnswer, "");
                      }

                      // this.props.setFieldValue(`${this.props.prefixName}answers`, newDate);
                    }}
                    onBlur={(e) => {
                      if (e) {
                        this.props.onBlur(e);
                      }
                    }}
                    placeholder="Data od"
                    isInvalid={!!this.props.errors.answers}
                    locale="pl"
                    readOnly={this.props.disabled}
                    autocomplete="off"
                  />
                </label>
              </div>
              {typeof this.props.errors.answers === "string" && (
                <Form.Control.Feedback
                  type="invalid"
                  className="field--invalid"
                >
                  {this.props.errors.answers}
                </Form.Control.Feedback>
              )}
              {this.props.canComment && (
                <div className="field field--question">
                  <Form.Control
                    disabled={
                      this.props.disabled ||
                      questionAnswer.answerOptions[0] == null ||
                      questionAnswer.answerOptions[0].openDate === null
                    }
                    id={`${this.props.prefixName}comment`}
                    name={`${this.props.prefixName}comment`}
                    type="text"
                    className="field__input"
                    value={
                      questionAnswer.answerOptions[0]
                        ? questionAnswer.answerOptions[0].comment
                        : ""
                    }
                    placeholder={"Skomentuj odpowiedź"}
                    onChange={(e) => {
                      this.onSingleCommentChange(
                        questionAnswer,
                        e.target.value
                      );
                      // this.props.onChange(e);
                    }}
                    autocomplete="off"
                  />
                </div>
              )}
            </Form.Group>
          )}
          {this.props.questionType == QuestionType.MultipleCheck && (
            <Form.Group>
              {this.props.questionOptions.length > 0 &&
                this.props.questionOptions.map((item, index) => (
                  <Fragment>
                    <p
                      style={{
                        visibility: "hidden",
                        width: "0px",
                        height: "0px",
                        display: "none",
                      }}
                      id={`question-${this.props.rowId}-${index}`}
                    >
                      {`${item.content} odpowiedź do pytania ${this.props.rowId}`}
                    </p>
                    <label
                      className="question-options__option question-options__option--multi checkbox"
                      key={index}
                      tabindex="0"
                      role="checkbox"
                      aria-label={`${item.content} odpowiedź do pytania ${this.props.rowId}`}
                    >
                      <input
                        type="checkbox"
                        disabled={this.props.disabled}
                        key={index}
                        id={`${this.props.prefixName}answers`}
                        name={`${this.props.prefixName}answers`}
                        value={item.id}
                        checked={
                          questionAnswer.answerOptions.findIndex(
                            (opt) => opt.questionOptionId == item.id
                          ) > -1
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            this.onSingleChange(
                              questionAnswer,
                              parseInt(e.target.value)
                            );
                          } else {
                            //zakładam że skoro odznaczam w takim razie istnieje tablica odpowiedzi
                            let answerToUpdate = cloneDeep(questionAnswer);
                            let answerOptionNotToDelete =
                              answerToUpdate.answerOptions.filter(
                                (item) =>
                                  item.questionOptionId !=
                                  parseInt(e.target.value)
                              );
                            answerToUpdate.answerOptions =
                              answerOptionNotToDelete;
                            this.props.setFieldValue(
                              `${this.props.prefixName}answers`,
                              [answerToUpdate]
                            );
                          }
                          // this.props.onChange(e);
                        }}
                        onBlur={this.props.onBlur}
                        className="checkbox__input question-options__option-input"
                        aria-labelledby={`question-${this.props.rowId}-${index}`}
                      />
                      <span className="row row--align-center question-options__option-button">
                        <span className="question-options__option-left">
                          <span className="checkbox__button question-options__option-checkbox" />
                        </span>
                        <span>{item.content}</span>
                      </span>
                    </label>
                    {this.props.canComment && (
                      <div className="field field--question">
                        <Form.Control
                          disabled={
                            this.props.disabled ||
                            questionAnswer.answerOptions.filter(
                              (options) => options.questionOptionId === item.id
                            ).length == 0
                          }
                          id={`${this.props.prefixName}comment`}
                          name={`${this.props.prefixName}comment`}
                          type="text"
                          className="field__input"
                          value={
                            questionAnswer.answerOptions.filter(
                              (options) => options.questionOptionId === item.id
                            ).length > 0
                              ? questionAnswer.answerOptions.filter(
                                  (options) =>
                                    options.questionOptionId === item.id
                                )[0].comment
                              : ""
                          }
                          placeholder={"Skomentuj odpowiedź"}
                          onChange={(e) => {
                            this.onMultipleCommentChange(
                              questionAnswer,
                              e.target.value,
                              item.id
                            );
                            // this.props.onChange(e);
                          }}
                          autocomplete="off"
                        />
                      </div>
                    )}
                  </Fragment>
                ))}
              {typeof this.props.errors.answers === "string" && (
                <Form.Control.Feedback
                  type="invalid"
                  className="field--invalid"
                >
                  {this.props.errors.answers}
                </Form.Control.Feedback>
              )}
            </Form.Group>
          )}
          {this.props.questionType == QuestionType.Ranking && (
            <Fragment>
              <QuestionRankingField
                questionOptions={questionOptions}
                disabled={this.props.disabled}
                movePosition={(questionOptions, oldIndex, newIndex) =>
                  this.movePosition(
                    questionOptions,
                    oldIndex,
                    newIndex,
                    questionAnswer
                  )
                }
                moveUp={(index, questionOptions) =>
                  this.moveUp(index, questionAnswer, questionOptions)
                }
                moveDown={(index, questionOptions) =>
                  this.moveDown(index, questionAnswer, questionOptions)
                }
              />
              {typeof this.props.errors.answers === "string" && (
                <Form.Control.Feedback
                  type="invalid"
                  className="field--invalid"
                >
                  {this.props.errors.answers}
                </Form.Control.Feedback>
              )}
            </Fragment>
          )}
          {this.props.questionType == QuestionType.Matrix && (
            <Fragment>
              <div className="row">
                <div className="matrix-question">
                  <div className="matrix-question__row row row--bottom-15 row--nowrap">
                    {this.props.questionMatrixValues.length > 0 &&
                      this.props.questionMatrixValues.map((item, index) => (
                        <div
                          className="text matrix-question__head text--alert"
                          key={index}
                        >
                          {item.content}
                        </div>
                      ))}
                  </div>
                  {questionOptions.length > 0 &&
                    questionOptions.map((itemOption, idx) => (
                      <div
                        key={idx}
                        className="matrix-question__row matrix-question__row--options row row--nowrap"
                        role="radiogroup"
                      >
                        <div className="matrix-question__name text">
                          {itemOption.content}
                        </div>
                        {this.props.questionMatrixValues.length > 0 &&
                          this.props.questionMatrixValues.map(
                            (itemMatrix, index) => (
                              <Fragment>
                                <p
                                  style={{
                                    visibility: "hidden",
                                    width: "0px",
                                    height: "0px",
                                    display: "none",
                                  }}
                                  id={`question-${idx}-${this.props.rowId}-${index}`}
                                >
                                  {`${idx}. ${itemMatrix.content} odpowiedź do pytania ${this.props.rowId}`}
                                </p>
                                <label
                                  className="radio matrix-question__option row row--justify-center row--align-center"
                                  tabindex="0"
                                  role="radio"
                                  aria-label={`${idx}. ${itemMatrix.content} odpowiedź do pytania ${this.props.rowId}`}
                                >
                                  <input
                                    type="radio"
                                    className="radio__input"
                                    disabled={this.props.disabled}
                                    key={`${idx}.${index}`}
                                    type="radio"
                                    name={`${this.props.prefixName}answersMatrix.${idx}`}
                                    value={itemMatrix.id}
                                    checked={
                                      questionAnswer.answerOptions.findIndex(
                                        (opt) =>
                                          opt.questionOptionId ==
                                            itemOption.id &&
                                          opt.questionMatrixValueId ==
                                            itemMatrix.id
                                      ) > -1
                                    }
                                    onChange={(e) => {
                                      if (
                                        questionAnswer.answerOptions[0] &&
                                        (questionAnswer.answerOptions[0].id >
                                          0 ||
                                          questionAnswer.answerOptions[0]
                                            .questionOptionId > 0)
                                      ) {
                                        let answerToUpdate =
                                          cloneDeep(questionAnswer);
                                        let answerOptionToUpdate =
                                          answerToUpdate.answerOptions.filter(
                                            (item) =>
                                              item.questionOptionId ==
                                              itemOption.id
                                          );
                                        if (answerOptionToUpdate.length > 0) {
                                          let answerOptionNotToDelete =
                                            answerToUpdate.answerOptions.filter(
                                              (item) =>
                                                item.questionOptionId !=
                                                itemOption.id
                                            );
                                          answerToUpdate.answerOptions =
                                            answerOptionNotToDelete;
                                          answerOptionToUpdate[0].questionMatrixValueId =
                                            parseInt(e.target.value);
                                          answerToUpdate.answerOptions.push(
                                            answerOptionToUpdate[0]
                                          );
                                        } else {
                                          let newAnswerOption = {
                                            id: 0,
                                            comment: "",
                                            openText: "",
                                            openDate: null,
                                            questionOptionId: itemOption.id,
                                            questionMatrixValueId: parseInt(
                                              e.target.value
                                            ),
                                          };
                                          answerToUpdate.answerOptions.push(
                                            newAnswerOption
                                          );
                                        }
                                        this.props.setFieldValue(
                                          `${this.props.prefixName}answers`,
                                          [answerToUpdate]
                                        );
                                      } else {
                                        let newAnswer = [
                                          {
                                            id: 0,
                                            questionId: this.props.id,
                                            userId: this.props.loggedUserId,
                                            categoryId: this.props.categoryId,
                                            answerOptions: [
                                              {
                                                id: 0,
                                                comment: "",
                                                openText: "",
                                                openDate: null,
                                                questionOptionId: itemOption.id,
                                                questionMatrixValueId: parseInt(
                                                  e.target.value
                                                ),
                                              },
                                            ],
                                          },
                                        ];
                                        this.props.setFieldValue(
                                          `${this.props.prefixName}answers`,
                                          newAnswer
                                        );
                                      }
                                      // this.props.onChange(e);
                                    }}
                                    onBlur={this.props.onBlur}
                                    isInvalid={
                                      this.props.errors.answers
                                        ? !!this.props.errors.answers[0]
                                            .answerOptions
                                        : false
                                    }
                                    aria-labelledby={`question-${idx}-${this.props.rowId}-${index}`}
                                  />
                                  <span className="radio__circle" />
                                </label>
                              </Fragment>
                            )
                          )}
                      </div>
                    ))}
                </div>
              </div>
              {this.props.errors.answers &&
                typeof this.props.errors.answers[0].answerOptions ===
                  "string" && (
                  <Form.Control.Feedback
                    type="invalid"
                    className="field--invalid"
                  >
                    {this.props.errors.answers[0].answerOptions}
                  </Form.Control.Feedback>
                )}
              {this.props.errors.answers &&
                typeof this.props.errors.answers ===
                  "string" && (
                  <Form.Control.Feedback
                    type="invalid"
                    className="field--invalid"
                  >
                    {this.props.errors.answers}
                  </Form.Control.Feedback>
                )}
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

Question.propTypes = {
  consultationFormType: PropTypes.number,
  canComment: PropTypes.bool,
  categoryId: PropTypes.number,
  categoryIndex: PropTypes.number,
  content: PropTypes.string,
  disabled: PropTypes.bool,
  formIndex: PropTypes.number,
  id: PropTypes.number,
  loggedUserId: PropTypes.number,
  maxPoint: PropTypes.number,
  order: PropTypes.number,
  prefixName: PropTypes.string,
  projectType: PropTypes.number,
  questionAnswerIdx: PropTypes.number,
  questionIndex: PropTypes.number,
  questionOptionCount: PropTypes.number,
  questionType: PropTypes.number,
  rowId: PropTypes.number,

  questionAnswer: PropTypes.shape({
    id: PropTypes.number,
    questionId: PropTypes.number,
    userId: PropTypes.number,
    categoryId: PropTypes.number,
    answerOptions: PropTypes.arrayOf(
      PropTypes.shape({
        comment: PropTypes.string,
        id: PropTypes.number,
        openDate: PropTypes.date,
        openText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        questionMatrixValueId: PropTypes.number,
        questionOptionId: PropTypes.number,
        ranking: PropTypes.number,
      })
    ),
  }),
  questionMatrixValues: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string,
      id: PropTypes.number,
      order: PropTypes.number,
    })
  ),
  questionOptions: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string,
      id: PropTypes.number,
      order: PropTypes.number,
    })
  ),
  isPreview: PropTypes.bool,

  errors: PropTypes.any,

  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  setFieldTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
};

Question.defaultProps = {
  subQuestion: false,
  canComment: false,
  categoryId: 0,
  categoryIndex: 0,
  consultationFormType: 0,
  content: 0,
  disabled: false,
  formIndex: 0,
  id: 0,
  loggedUserId: 0,
  maxPoint: 0,
  order: 0,
  prefixName: "",
  projectType: 0,
  questionIndex: 0,
  questionOptionCount: 0,
  questionType: 0,
  rowId: 0,
  isPreview: false,

  errors: {},

  questionAnswer: {
    categoryId: 0,
    id: 0,
    questionId: 0,
    userId: 0,
    answerOptions: [
      {
        comment: "",
        id: 0,
        openDate: null,
        openText: "",
        questionMatrixValueId: 0,
        questionOptionId: 0,
        ranking: 0,
      },
    ],
  },
  questionMatrixValues: [],
  questionOptions: [],

  onChange: Function.prototype,
  onBlur: Function.prototype,
  setFieldValue: Function.prototype,
  setFieldTouched: Function.prototype,
};

// className="field__input field__input--datepicker"
